<section>
<h1 mat-dialog-title>
  <p *ngIf="showOk" class="error_header">Error occurred while submitting data to Walgreens! <br> Clinic Information will be updated and will continue to function as normal within our system.</p>
</h1>
<div mat-dialog-content>
  <div *ngIf="!showOk">
  {{data.body}}
  </div>
  <div *ngIf="showOk">
    <ul>
      <li *ngFor="let error of errorMessage">{{error}}.</li>
    </ul>
</div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()" *ngIf="!showOk">No</button>
  <button mat-button mat-dialog-close="yes" cdkFocusInitial *ngIf="!showOk">Yes</button>
  <button mat-button mat-dialog-close="yes" cdkFocusInitial *ngIf="showOk">OK</button>
</div>
</section>
